"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonEncryptRequestImpl = void 0;
var encrypt_abstract_1 = require("../request-encrypt/encrypt-abstract");
var middleware_encrypt_v5_1 = require("../utils/middleware-encrypt-v5");
var CommonEncryptRequestImpl = /** @class */ (function (_super) {
    __extends(CommonEncryptRequestImpl, _super);
    function CommonEncryptRequestImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommonEncryptRequestImpl.prototype.request = function (params) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var _a, data, method, url, baseUrl, headers, isEncrypt, reset, _b, _headers, _data, _decrypt, promise, _responseResult, e_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 3, , 4]);
                        _a = params.data, data = _a === void 0 ? '' : _a, method = params.method, url = params.url, baseUrl = params.baseUrl, headers = params.headers, isEncrypt = params.isEncrypt, reset = __rest(params, ["data", "method", "url", "baseUrl", "headers", "isEncrypt"]);
                        return [4 /*yield*/, (0, middleware_encrypt_v5_1.setIsEncryptParams)({
                                data: data,
                                headers: headers,
                                isEncrypt: isEncrypt,
                                method: method,
                            })];
                    case 1:
                        _b = _c.sent(), _headers = _b._headers, _data = _b._data, _decrypt = _b._decrypt;
                        promise = this.load(__assign(__assign({}, reset), { method: method, url: (0, middleware_encrypt_v5_1.getUrl)(url, baseUrl), body: _data, headers: _headers }))[0];
                        return [4 /*yield*/, promise];
                    case 2:
                        _responseResult = _c.sent();
                        if (_responseResult && _responseResult.data && _decrypt) {
                            _responseResult.data = JSON.parse(_decrypt(_responseResult.data));
                        }
                        resolve(_responseResult);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _c.sent();
                        console.error('[ai sdk CommonEncryptRequestImpl request error', e_1);
                        reject(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); });
    };
    CommonEncryptRequestImpl.prototype.requestCancelable = function (params) {
        var _this = this;
        return new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
            var _a, data, url, baseUrl, _b, headers, isEncrypt, method, reset, _c, _headers, _data, _decrypt, _d, promise, controller_1, abortFn, e_2;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 2, , 3]);
                        _a = params.data, data = _a === void 0 ? '' : _a, url = params.url, baseUrl = params.baseUrl, _b = params.headers, headers = _b === void 0 ? {} : _b, isEncrypt = params.isEncrypt, method = params.method, reset = __rest(params, ["data", "url", "baseUrl", "headers", "isEncrypt", "method"]);
                        return [4 /*yield*/, (0, middleware_encrypt_v5_1.setIsEncryptParams)({
                                data: data,
                                headers: headers,
                                isEncrypt: isEncrypt,
                                method: method,
                            })];
                    case 1:
                        _c = _e.sent(), _headers = _c._headers, _data = _c._data, _decrypt = _c._decrypt;
                        _d = this.load(__assign(__assign({}, reset), { url: (0, middleware_encrypt_v5_1.getUrl)(url, baseUrl), body: _data, method: method, headers: _headers }), _decrypt), promise = _d[0], controller_1 = _d[1];
                        abortFn = function () {
                            controller_1.abort();
                        };
                        resolve([promise, abortFn]);
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _e.sent();
                        // 无需reject，因为外部会捕获异常
                        console.log('[ai sdk CommonEncryptRequestImpl requestCancelable error', e_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    return CommonEncryptRequestImpl;
}(encrypt_abstract_1.EncryptRequestAbstract));
exports.CommonEncryptRequestImpl = CommonEncryptRequestImpl;
exports.default = new CommonEncryptRequestImpl();
